<template>
  <div
    id="m_quick_sidebar"
    class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light m-quick-sidebar--on"
  >
    <div class="m-quick-sidebar__content">
      <span class="m-quick-sidebar__close mt-2" @click="closeThis()">
        <i class="fal fa-times-circle fa-lg"></i>
      </span>
      <ul
        id="m_quick_sidebar_tabs"
        class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand"
        role="tablist"
      >
        <li class="nav-item m-tabs__item">
          <a class="nav-link m-tabs__link" data-toggle="tab" href="#pending_log_history" role="tab">
            <h5><span class="far fa-history"></span> Logs de Faturas Pendentes</h5>
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane active" id="pending_log_history" role="tabpanel">
          <PendingInvoiceLogHistory />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PendingInvoiceLogHistory from '@/components/invoices/pending-invoices/PendingInvoiceLogHistory';

export default {
  name: 'PendingInvoiceLogModal',
  components: {
    PendingInvoiceLogHistory,
  },
  methods: {
    closeThis() {
      this.$store.state.showPendingInvoiceJobLogs = null;
    },
  },
  computed: {},
};
</script>
<style>
.m-quick-sidebar-overlay {
  background: rgba(0, 0, 0, 0.3);
}

@media (min-width: 1201px) {
  #m_quick_sidebar {
    width: 50% !important;
  }
}

@media (min-width: 601px) and (max-width: 1200px) {
  #m_quick_sidebar {
    width: 60% !important;
  }
}

@media (max-width: 600px) {
  #m_quick_sidebar {
    width: 100% !important;
  }
}
</style>
